import React from "react";
import GuestScrollReveal from "./GuestScrollReveal";
import {
    FOOTER_LEGAL_LINKS,
    FOOTER_NAV_LINKS,
    GUEST_SOCIAL_LINKS,
} from "../../data/guestPageData";
import discordIcon from "../../media/guestpage/Discord.svg";
import telegramIcon from "../../media/guestpage/Telegram.svg";
import youtubeIcon from "../../media/guestpage/Youtube.svg";
import twitchIcon from "../../media/guestpage/Twitch.svg";
import vkIcon from "../../media/guestpage/WK.svg";
import tiktokIcon from "../../media/guestpage/TikTok.svg";

const SOCIAL_ICONS = {
    discord: discordIcon,
    telegram: telegramIcon,
    youtube: youtubeIcon,
    twitch: twitchIcon,
    vk: vkIcon,
    tiktok: tiktokIcon,
};

const GuestFooter = () => {
    const handleAnchorClick = (event, href) => {
        if (!href.startsWith("#")) {
            return;
        }

        event.preventDefault();
        const target = document.querySelector(href);

        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <footer className="guest-footer">
            <div className="guest-container">
                <GuestScrollReveal>
                    <div className="guest-footer__top">
                    <div className="guest-footer__brand">
                        MEDIEVAL
                        <br />
                        ROLEPLAY
                    </div>
                    <div className="guest-footer__socials">
                        {GUEST_SOCIAL_LINKS.map((social) => (
                            <a
                                key={social.id}
                                href={social.href}
                                target="_blank"
                                rel="noreferrer"
                                className={`guest-footer__social-link guest-footer__social-link--${social.id}`}
                                aria-label={social.label}
                            >
                                <img
                                    src={SOCIAL_ICONS[social.id]}
                                    alt=""
                                    aria-hidden="true"
                                />
                            </a>
                        ))}
                    </div>
                    </div>
                </GuestScrollReveal>

                <GuestScrollReveal delay={0.06}>
                    <div className="guest-footer__columns">
                    <nav className="guest-footer__column" aria-label="Навигация">
                        {FOOTER_NAV_LINKS.map((link) => (
                            <a
                                key={link.label}
                                href={link.href}
                                onClick={(event) =>
                                    handleAnchorClick(event, link.href)
                                }
                            >
                                {link.label}
                            </a>
                        ))}
                    </nav>

                    <nav
                        className="guest-footer__column"
                        aria-label="Документы"
                    >
                        {FOOTER_LEGAL_LINKS.map((link) => (
                            <a
                                key={link.label}
                                href={link.href}
                                target={
                                    link.href.endsWith(".pdf")
                                        ? "_blank"
                                        : undefined
                                }
                                rel={
                                    link.href.endsWith(".pdf")
                                        ? "noreferrer"
                                        : undefined
                                }
                            >
                                {link.label}
                            </a>
                        ))}
                    </nav>

                    <div className="guest-footer__column guest-footer__column--copyright">
                        <p>© 2026. Medieval Role Play. Все права защищены.</p>
                    </div>
                    </div>
                </GuestScrollReveal>
            </div>
        </footer>
    );
};

export default GuestFooter;
